<script setup lang="ts">
import ClassDetails from '../../components/Class/ClassDetails.vue';
import ClassSchedule from '../../components/Class/ClassSchedule.vue';
import StudentList from '../../components/Class/StudentList.vue';
import RaiseHandList from '../../components/Control/RaiseHandList.vue';
import { useClassStore } from '../../stores';
import { ClassStatus, ClassViewMode } from '../../types/class';
import LockScreen from '../../components/Control/LockScreen.vue';
import Session from '../../components/Session/Session.vue';
import ClassEnding from '../../components/Notification/ClassEnding.vue';

const classStore = useClassStore()
</script>

<template>
    <ClassSchedule v-if="!classStore.selectedClassDetails" />
    <div v-else class="h-full flex-col flex flex-1 gap-3 rounded-lg bg-neutral-100 p-3 md:p-5 relative overflow-auto">
        <template v-if="classStore.viewMode === ClassViewMode.management">
            <ClassDetails />
            <StudentList />
        </template>
        <template v-if="classStore.viewMode === ClassViewMode.teaching">
            <Session />
            <div class="flex flex-wrap gap-3 items-center justify-center"
                v-if="classStore.selectedClassDetails.state === ClassStatus.on_going">
                <RaiseHandList />
                <LockScreen class="mx-auto" />
            </div>
        </template>
    </div>
    <ClassEnding />
</template>